import { App_Url_New } from "@/src_new/shared/common/static";
import { dispatchRetailSessionExpired } from "@/src_new/shared/lib/authSession";
import axios from "axios";

// Helper to get token from redux-persist
function getToken() {
  try {
    const persisted = localStorage.getItem("persist:protego-auth");

    console.log("customerAuth?.access_token", persisted);

    if (!persisted) return null;

    const root = JSON.parse(persisted);
    const customerAuth = root?.customerAuth ? JSON.parse(root.customerAuth) : null;
    const user = root?.user ? JSON.parse(root.user) : null;

    const tokens = user?.access_token || customerAuth?.access_token || null;

    return tokens;
  } catch {
    return null;
  }
}

const BASE_URL = import.meta.env.VITE_APP_ENDPOINT_URL;

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// Skip auth for specific APIs
function shouldSkipAuthHeader(url) {
  if (!url) return false;
  return url.includes("/users/create-session");
}

// ✅ REQUEST INTERCEPTOR (FIXED)
axiosInstance.interceptors.request.use(
  (config: any) => {
    const tokens = getToken();

    // ✅ IMPORTANT: If Authorization already passed manually, don't override it
    if (config.headers?.Authorization) {
      return config;
    }

    // ✅ Attach token from storage if available
    if (tokens && !shouldSkipAuthHeader(config.url)) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${tokens}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      dispatchRetailSessionExpired();
      localStorage.removeItem("persist:protego-auth");
      localStorage.removeItem("persistentPersonal");
      localStorage.removeItem("persistentTravel");
      localStorage.removeItem("resumeSessionData");
      localStorage.removeItem("coverageApiData");
      localStorage.removeItem("travel_step2_details");
      localStorage.removeItem("travel_step1_details");
      localStorage.removeItem("coverageOptionsWithIds");
      window.location.href = App_Url_New.secured.frontlinks.login;
    }
    return Promise.reject(error);
  }
);
